import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Every route opens at its top — a new screen never inherits the previous screen's scroll. */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, [pathname]);

  return null;
};
